import { gql } from '@apollo/client';
import { ReportSectionState } from '@mnd-frontend/graphql-schema';
import { GREY_900 } from '@mnd-frontend/ui/shared/tokens';
import type { Report2VisibilityBenchmarkShareOfVoiceFragment } from '../../../../../generated/types';
import { ShareOfMentionsGraph } from '../../charts';
import { Insights, Section, SectionHeader } from '../../common';

export const REPORT2_VISIBILITY_BENCHMARK_SHARE_OF_VOICE_FRAGMENT = gql`
  fragment Report2VisibilityBenchmarkShareOfVoice on ReportVisibilityBenchmarkShareOfVoice {
    id
    title
    state
    reportMetrics {
      brandName
      mentions
      hitIds
      share
      trendPercentage
    }
    competitorMetrics {
      searchProfileId
      brandName
      mentions
      hitIds
      share
      trendPercentage
    }
    insights2 {
      id
      title
      insight
      insightType
    }
  }
`;

const VisibilityBenchmarkShareOfVoice = ({
  section,
}: {
  section: Report2VisibilityBenchmarkShareOfVoiceFragment;
}) => {
  return (
    <Section>
      <SectionHeader
        color={GREY_900}
        as="h3"
        variant="reportHeadlineLarge"
        section={section}
        isSubsection
      />
      <ShareOfMentionsGraph
        loading={section.state !== ReportSectionState.Done}
        reportMetrics={section.reportMetrics}
        competitorMetrics={section.competitorMetrics}
      />
      <Insights insights={section.insights2} />
    </Section>
  );
};

export default VisibilityBenchmarkShareOfVoice;
